import { mapUrlToRootUrl } from "./utils";
const ROBOTS_TXT = "robots.txt";
/**
 * Look for a valid `robots.txt` and parse `Sitemap` url. Multiple sitemaps are supported.
 *
 * @see https://regex101.com/r/Trn97e/1
 * @see https://stackoverflow.com/a/3184966/5506547
 * @param forceSitemapArgument Append this query argument to the `robots.txt` in case you can server-side activate the sitemap
 */ async function findByRobots(url, forceSitemapArgument) {
    try {
        const query = forceSitemapArgument ? `${forceSitemapArgument}=1` : "";
        const response = await fetch(`${url}${ROBOTS_TXT}${query ? `?${query}` : ""}`);
        if (!response.ok) {
            return false;
        }
        const content = await response.text();
        const sitemapUrls = [
            ...content.matchAll(/^sitemap:(.*)$/gim)
        ].map((param)=>{
            let [, url] = param;
            return url.trim();
        });
        let result = [];
        for (const sitemapUrl of sitemapUrls){
            const correctedSitemapUrl = mapUrlToRootUrl(url, sitemapUrl, query);
            if (correctedSitemapUrl) {
                // Check if sitemap really exists and isn't stale (e.g. deactivate RankMath SEO WP plugin does not recreate robots.txt)
                const responseCheckSitemap = await fetch(correctedSitemapUrl);
                if (!responseCheckSitemap.ok) {
                    continue;
                }
                // Scenario: Sitemap does not exist but a plugin redirects directly to the homepage => no error code
                const body = await responseCheckSitemap.text();
                if (!/<(?:sitemap|urlset)/gm.test(body)) {
                    continue;
                }
                result.push(correctedSitemapUrl);
            }
        }
        result = [
            ...new Set(result)
        ];
        return result.length ? result : false;
    } catch (e) {
        return false;
    }
}
export { findByRobots };
